module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"company-name":"Nome da empresa"},"en-US":{"company-name":"Company Name"}}')
  delete Component.options._Ctor
}
